import { useContext } from 'react';
import CurrentUserContext from '../contexts/CurrentUser';

export default () => {
    const context = useContext(CurrentUserContext);

    return context;
};
